import React, { Component } from 'react';

import { ReactComponent as IconClose } from './../../assets/img/icon/icon-close.svg';
import { ReactComponent as IconAlert } from './../../assets/img/icon/icon-alert.svg';
import './serviceFee.scss';

// Banner merah Monthly Service Fee di atas header.
// closable (grace) → ada X, bisa ditutup utk session ini; non-closable (BASIC) → permanen.
const DISMISSED_KEY = 'skai1FeeBannerDismissed';

class GlobalServiceFeeBanner extends Component{
  constructor(props){
    super(props);

    this.state = {
      dismissed: sessionStorage.getItem(DISMISSED_KEY) === 'true',
    };

    this.dismiss = this.dismiss.bind(this);
  }

  visible(){
    const { show, closable } = this.props;
    // Baca flag live dari sessionStorage (bukan cache constructor) — flag di-reset di jalur
    // login, sedangkan komponen ini gak pernah remount (App mount sekali seumur tab).
    return show && !(closable && sessionStorage.getItem(DISMISSED_KEY) === 'true');
  }

  dismiss(){
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    this.setState({ dismissed: true }); // state cuma buat trigger re-render
  }

  render(){
    const { closable, onPay, t } = this.props;

    if(!this.visible()){
      return null;
    }

    return(
      <div className="service-fee-banner" role="alert">
        {/* icon ikut pesan (per Figma): basic "unlock the full" pakai ⚠️, grace "keep full access" tanpa */}
        {!closable ? <IconAlert className="service-fee-banner-icon" /> : ''}
        <span className="service-fee-banner-body">
          <span className="service-fee-banner-text">{t(closable ? 'serviceFee.bannerGrace' : 'serviceFee.bannerBasic')}</span>
          {' '}
          <button type="button" className="service-fee-banner-link" onClick={onPay}>
            {t('serviceFee.bannerLink')}
          </button>
        </span>
        {closable ? (
          <button type="button" className="service-fee-banner-close" onClick={this.dismiss} aria-label={t('serviceFee.close')}>
            <IconClose />
          </button>
        ) : ''}
      </div>
    );
  }
}

export default GlobalServiceFeeBanner;
